<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // 业务名称
            label: '业务名称',
            value: 'bizName',
            type: 'input',
            placeholder: '请输入业务名称',
          },
          { // 批次号码
            label: '批次号码',
            value: 'batchId',
            type: 'input',
            placeholder: '请输入批次号码',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
